import { render, staticRenderFns } from "./ProductInventory.vue?vue&type=template&id=bafcf04c&scoped=true"
import script from "./ProductInventory.vue?vue&type=script&lang=js"
export * from "./ProductInventory.vue?vue&type=script&lang=js"
import style0 from "./ProductInventory.vue?vue&type=style&index=0&id=bafcf04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafcf04c",
  null
  
)

export default component.exports